import React from "react";
import { Helmet } from "react-helmet";
const BlogGPTHelmet = ({ title }) => {
  return (
    <Helmet>
      
      <title>
       ChatGPT Atlas vs Google Chrome: Which Is Better?
      </title>
      <meta
        name="description"
        content="ChatGPT Atlas vs Google Chrome: Which Browser Is Better? Compare AI features, speed, and privacy to choose your ultimate browsing tool."
      />
    </Helmet>
  );
};

export default BlogGPTHelmet;
